function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Tinymce from '@/components/Tinymce/index';
import { templateListApi, productCreateApi, categoryApi, productDetailApi, productUpdateApi, guaranteeListApi } from '@/api/store';
import { marketingSendApi } from '@/api/marketing';
import { shippingTemplatesList } from '@/api/logistics';
import { goodDesignList } from '@/api/systemGroup';
import { arraysEqual } from '@/utils';
import { clearTreeData } from '@/utils/ZBKJIutil';
import CreatTemplates from '@/views/systemSetting/deliverGoods/freightSet/creatTemplates';
import creatAttr from '../components/creatAttr';
import Templates from '../../appSetting/wxAccount/wxTemplate/index';
import { Debounce } from '@/utils/validate';
import { copyConfigApi, copyProductApi } from '@/api/store';
var defaultObj = {
  image: '',
  sliderImages: [],
  videoLink: '',
  sliderImage: '',
  storeName: '',
  keyword: '',
  cateIds: [],
  // 商品分类id
  cateId: null,
  // 商品分类id传值
  unitName: '',
  productType: '',
  // 商品类型：1-商城，2-团购
  temperatureType: '',
  // 温控类型：1-常温，2-冷藏，3-冷冻
  productDesc: '',
  // 产品列表描述文本
  descColor: '#040000',
  // 文本颜色，十六进制色值
  couponAllow: 1,
  // 是否可以使用优惠券：0-不允许，1-允许
  limitNum: 0,
  // 限购数量，0-不限购
  deliveryTime: '',
  // 送达时间（团购商品专用，精确到时分秒）
  cutoffDate: '',
  // 下架时间（团购商品专用）
  ingredientList: '',
  // 用于小程序详情展示表格
  storePointName: '',
  // 自提点名称
  sort: 0,
  giveIntegral: 0,
  ficti: 0,
  isShow: false,
  isBenefit: false,
  isNew: false,
  isGood: false,
  isHot: false,
  isBest: false,
  tempId: '',
  attrValue: [{
    image: '',
    price: void 0,
    cost: void 0,
    otPrice: void 0,
    stock: void 0,
    barCode: '',
    weight: void 0,
    volume: void 0,
    brokerageType: 1,
    // 分佣类型：1-比例分佣，2-固定金额分佣
    brokerageRate: void 0,
    // 分佣比例
    brokerage: void 0 // 固定金额
  }],
  attr: [],
  selectRule: '',
  isSub: true,
  content: '',
  specType: false,
  id: 0,
  couponIds: [],
  coupons: [],
  guaranteeIds: '',
  // 服务保障id字符串
  activity: ['默认', '秒杀', '砍价', '拼团']
};
var objTitle = {
  price: {
    title: '售价'
  },
  cost: {
    title: '成本价'
  },
  otPrice: {
    title: '原价'
  },
  stock: {
    title: '库存'
  },
  barCode: {
    title: '商品编号'
  },
  weight: {
    title: '重量（KG）'
  },
  volume: {
    title: '体积(m³)'
  }
};
export default {
  name: 'SortCreat',
  components: {
    Templates: Templates,
    CreatTemplates: CreatTemplates,
    Tinymce: Tinymce,
    creatAttr: creatAttr
  },
  data: function data() {
    var _this2 = this;
    return {
      htmlKey: 0,
      isDisabled: this.$route.params.isDisabled === '1' ? true : false,
      activity: {
        默认: 'red',
        秒杀: 'blue',
        砍价: 'green',
        拼团: 'yellow'
      },
      props2: {
        children: 'child',
        label: 'name',
        value: 'id',
        multiple: true,
        emitPath: false
      },
      checkboxGroup: [],
      recommend: [],
      productTypeList: [],
      // 商品类型字典
      temperatureTypeList: [],
      // 温控类型字典
      tabs: [],
      fullscreenLoading: false,
      props: {
        multiple: true
      },
      active: 0,
      OneattrValue: [Object.assign({}, defaultObj.attrValue[0])],
      // 单规格
      ManyAttrValue: [Object.assign({}, defaultObj.attrValue[0])],
      // 多规格
      ruleList: [],
      merCateList: [],
      // 商品分类筛选
      shippingList: [],
      // 运费模板
      formThead: Object.assign({}, objTitle),
      formValidate: Object.assign({}, defaultObj),
      formDynamics: {
        ruleName: '',
        ruleValue: []
      },
      tempData: {
        page: 1,
        limit: 9999
      },
      manyTabTit: {},
      manyTabDate: {},
      grid2: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24
      },
      // 规格数据
      formDynamic: {
        attrsName: '',
        attrsVal: ''
      },
      isBtn: false,
      manyFormValidate: [],
      currentTab: 0,
      isChoice: '',
      grid: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24
      },
      ruleValidate: {
        storeName: [{
          required: true,
          message: '请输入商品名称',
          trigger: 'blur'
        }],
        couponAllow: [{
          required: true,
          message: '请选择是否可以使用优惠券',
          trigger: 'change'
        }],
        limitNum: [{
          required: true,
          message: '请输入限购数量',
          trigger: 'blur'
        }],
        cateIds: [{
          required: true,
          message: '请选择商品分类',
          trigger: 'change',
          type: 'array',
          min: '1'
        }],
        keyword: [{
          required: true,
          message: '请输入商品关键字',
          trigger: 'blur'
        }],
        unitName: [{
          required: true,
          message: '请输入单位',
          trigger: 'blur'
        }],
        productType: [{
          required: true,
          message: '请选择商品类型',
          trigger: 'change'
        }],
        temperatureType: [{
          required: true,
          message: '请选择温控类型',
          trigger: 'change'
        }],
        productDesc: [{
          required: true,
          message: '请输入产品描述',
          trigger: 'blur'
        }],
        descColor: [{
          required: true,
          message: '请选择文本颜色',
          trigger: 'change'
        }],
        cutoffDate: [{
          validator: function validator(rule, value, callback) {
            if (_this2.formValidate.productType === '2' && !value) {
              callback(new Error('请选择下架时间'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        deliveryTime: [{
          validator: function validator(rule, value, callback) {
            if (_this2.formValidate.productType === '2' && !value) {
              callback(new Error('请选择送达时间'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        tempId: [{
          required: true,
          message: '请选择运费模板',
          trigger: 'change'
        }],
        image: [{
          required: true,
          message: '请上传商品图',
          trigger: 'change'
        }],
        sliderImages: [{
          required: true,
          message: '请上传商品轮播图',
          type: 'array',
          trigger: 'change'
        }],
        specType: [{
          required: true,
          message: '请选择商品规格',
          trigger: 'change'
        }]
      },
      attrInfo: {},
      tableFrom: {
        page: 1,
        limit: 9999,
        keywords: ''
      },
      tempRoute: {},
      keyNum: 0,
      isAttr: false,
      showAll: false,
      videoLink: '',
      copyConfig: {},
      url: '',
      guaranteeList: [],
      // 服务保障列表
      guaranteeIdsList: [],
      // 服务保障选择id列表
      // 批量添加数据
      oneFormBatch: [Object.assign({}, defaultObj.attrValue[0])]
    };
  },
  computed: {
    attrValue: function attrValue() {
      var obj = Object.assign({}, defaultObj.attrValue[0]);
      delete obj.image;
      return obj;
    }
  },
  watch: {
    // 'formValidate.attr': {
    //   handler: function (val) {
    //     // 如果是多规格商品
    //     if (this.formValidate.specType) {
    //       // 生成规格属性表头
    //       this.generateHeader(val);
    //       // 生成规格属性数据
    //       this.ManyAttrValue = this.generateAttr(val);
    //     }
    //     // if (this.formValidate.specType) this.watCh(val); //重要！！！
    //   },
    //   immediate: false,
    //   deep: true,
    // },
  },
  created: function created() {
    this.tempRoute = Object.assign({}, this.$route);
    if (this.$route.params.id && this.formValidate.specType) {
      // this.$watch('formValidate.attr', this.watCh);
    }
    // 获取服务保障列表
    this.getGuaranteeList();
  },
  mounted: function mounted() {
    this.getCopyConfig();
    this.getTemperatureType();
    this.getProductType();
    this.formValidate.sliderImages = [];
    if (this.$route.params.id) {
      this.setTagsViewTitle();
      this.getInfo();
    }
    this.getCategorySelect();
    this.getShippingList();
    this.getGoodsType();
  },
  methods: {
    addProduct: function addProduct() {
      var _this3 = this;
      if (this.url) {
        this.loading = true;
        this.copyConfig.copyType == 1 ? copyProductApi({
          url: this.url
        }).then(function (res) {
          var info = res;
          _this3.formValidate = {
            image: _this3.$selfUtil.setDomain(info.image),
            sliderImage: info.sliderImage,
            storeName: info.storeName,
            keyword: info.keyword,
            cateIds: info.cateId ? info.cateId.split(',') : [],
            // 商品分类id
            cateId: info.cateId,
            // 商品分类id传值
            unitName: info.unitName,
            sort: 0,
            isShow: 0,
            isBenefit: false,
            isNew: false,
            isGood: false,
            isHot: false,
            isBest: false,
            tempId: info.tempId,
            attrValue: info.attrValue,
            attr: info.attr || [],
            selectRule: info.selectRule,
            isSub: false,
            content: _this3.$selfUtil.replaceImgSrcHttps(info.content),
            specType: info.attr.length ? true : false,
            id: info.id,
            giveIntegral: info.giveIntegral,
            ficti: info.ficti,
            couponAllow: info.couponAllow !== undefined ? info.couponAllow : 1,
            // 是否可以使用优惠券：0-不允许，1-允许
            limitNum: info.limitNum || 0,
            // 限购数量，0-不限购
            activity: ['默认', '秒杀', '砍价', '拼团'],
            deliveryTime: info.deliveryTime,
            cutoffDate: info.cutoffDate,
            ingredientList: info.ingredientList
          };
          if (info.specType) {
            // 设置多规格商品属性数据
            _this3.generateManyAttr();
          } else {
            _this3.OneattrValue = info.attrValue;
          }
          if (info.isHot) _this3.checkboxGroup.push('isHot');
          if (info.isGood) _this3.checkboxGroup.push('isGood');
          if (info.isBenefit) _this3.checkboxGroup.push('isBenefit');
          if (info.isBest) _this3.checkboxGroup.push('isBest');
          if (info.isNew) _this3.checkboxGroup.push('isNew');
          var imgs = JSON.parse(info.sliderImage);
          var imgss = [];
          Object.keys(imgs).map(function (i) {
            imgss.push(_this3.$selfUtil.setDomain(imgs[i]));
          });
          _this3.formValidate.sliderImages = imgss;
          if (_this3.formValidate.attr.length) {
            _this3.oneFormBatch[0].image = _this3.$selfUtil.setDomain(info.image);
            _this3.oneFormBatch[0].brokerageType = 1; // 设置采集商品的默认分佣类型
            _this3.oneFormBatch[0].brokerageRate = 0; // 设置采集商品的默认分佣比例
            _this3.oneFormBatch[0].brokerage = 0; // 设置采集商品的默认固定金额
            for (var i = 0; i < _this3.formValidate.attr.length; i++) {
              _this3.formValidate.attr[i].attrValue = JSON.parse(_this3.formValidate.attr[i].attrValues);
            }
          }
          _this3.loading = false;
        }).catch(function () {
          _this3.loading = false;
        }) : importProductApi({
          url: this.url,
          form: this.form
        }).then(function (res) {
          _this3.formValidate = {
            image: _this3.$selfUtil.setDomain(res.image),
            sliderImage: res.sliderImage,
            storeName: res.storeName,
            keyword: res.keyword,
            cateIds: res.cateId ? res.cateId.split(',') : [],
            // 商品分类id
            cateId: res.cateId,
            // 商品分类id传值
            unitName: res.unitName,
            sort: 0,
            isShow: 0,
            isBenefit: false,
            isNew: false,
            isGood: false,
            isHot: false,
            isBest: false,
            tempId: res.tempId,
            attrValue: res.attrValue,
            attr: res.attr || [],
            selectRule: res.selectRule,
            isSub: false,
            content: res.content,
            specType: res.attr.length ? true : false,
            id: res.id,
            giveIntegral: res.giveIntegral,
            ficti: res.ficti,
            couponAllow: res.couponAllow !== undefined ? res.couponAllow : 1,
            // 是否可以使用优惠券：0-不允许，1-允许
            limitNum: res.limitNum || 0,
            // 限购数量，0-不限购
            activity: ['默认', '秒杀', '砍价', '拼团'],
            deliveryTime: res.deliveryTime,
            cutoffDate: res.cutoffDate,
            ingredientList: res.ingredientList
          };
          if (info.specType) {
            // 设置多规格商品属性数据
            _this3.generateManyAttr();
          } else {
            _this3.OneattrValue = info.attrValue;
            // this.formValidate.attr = [] //单规格商品规格设置为空
          }
          var imgs = JSON.parse(res.sliderImage);
          var imgss = [];
          Object.keys(imgs).map(function (i) {
            imgss.push(_this3.$selfUtil.setDomain(imgs[i]));
          });
          _this3.formValidate.sliderImages = imgss;
          if (_this3.formValidate.attr.length) {
            _this3.oneFormBatch[0].image = _this3.$selfUtil.setDomain(res.image);
            for (var i = 0; i < _this3.formValidate.attr.length; i++) {
              _this3.formValidate.attr[i].attrValue = JSON.parse(_this3.formValidate.attr[i].attrValues);
            }
          }
          _this3.loading = false;
        }).catch(function () {
          _this3.loading = false;
        });
      } else {
        this.$message.warning('请输入链接地址！');
      }
    },
    getCopyConfig: function getCopyConfig() {
      // copyConfigApi().then((res) => {
      //   this.copyConfig = res;
      // });
    },
    tabsHandleClick: function tabsHandleClick(tab, event) {
      this.currentTab = tab.name;
    },
    keyupEvent: function keyupEvent(key, val, index, num) {
      var re = /([0-9]+.[0-9]{2})[0-9]*/;
      switch (num) {
        case 1:
          this.oneFormBatch[index][key] = key === 'stock' ? parseInt(val) : this.$set(this.oneFormBatch[index], key, String(val).replace(re, '$1'));
          break;
        case 2:
          this.OneattrValue[index][key] = key === 'stock' ? parseInt(val) : this.$set(this.OneattrValue[index], key, String(val).replace(re, '$1'));
          break;
        default:
          this.ManyAttrValue[index][key] = key === 'stock' ? parseInt(val) : this.$set(this.ManyAttrValue[index], key, String(val).replace(re, '$1'));
          break;
      }
    },
    handleCloseCoupon: function handleCloseCoupon(tag) {
      this.isAttr = true;
      this.formValidate.coupons.splice(this.formValidate.coupons.indexOf(tag), 1);
      this.formValidate.couponIds.splice(this.formValidate.couponIds.indexOf(tag.id), 1);
    },
    addCoupon: function addCoupon() {
      var _this = this;
      this.$modalCoupon('wu', this.keyNum += 1, this.formValidate.coupons, function (row) {
        _this.formValidate.couponIds = [];
        _this.formValidate.coupons = row;
        row.map(function (item) {
          _this.formValidate.couponIds.push(item.id);
        });
      }, '');
    },
    setTagsViewTitle: function setTagsViewTitle() {
      var title = this.isDisabled ? '商品详情' : '编辑商品';
      var route = Object.assign({}, this.tempRoute, {
        title: "".concat(title, "-").concat(this.$route.params.id)
      });
      this.$store.dispatch('tagsView/updateVisitedView', route);
    },
    onChangeGroup: function onChangeGroup() {
      this.checkboxGroup.includes('isGood') ? this.formValidate.isGood = true : this.formValidate.isGood = false;
      this.checkboxGroup.includes('isBenefit') ? this.formValidate.isBenefit = true : this.formValidate.isBenefit = false;
      this.checkboxGroup.includes('isBest') ? this.formValidate.isBest = true : this.formValidate.isBest = false;
      this.checkboxGroup.includes('isNew') ? this.formValidate.isNew = true : this.formValidate.isNew = false;
      this.checkboxGroup.includes('isHot') ? this.formValidate.isHot = true : this.formValidate.isHot = false;
    },
    // 运费模板
    addTem: function addTem() {
      this.$refs.addTemplates.dialogVisible = true;
      this.$refs.addTemplates.getCityList();
    },
    // 商品分类；
    getCategorySelect: function getCategorySelect() {
      var _this4 = this;
      categoryApi({
        status: -1,
        type: 1
      }).then(function (res) {
        _this4.merCateList = _this4.addDisabled(res);
      });
    },
    //限制商品分类只能选择开启的
    addDisabled: function addDisabled(dropdownList) {
      var _this5 = this;
      var list = [];
      try {
        dropdownList.forEach(function (e, index) {
          var e_new = {
            id: e.id,
            name: e.name,
            level: e.level,
            pid: e.pid,
            sort: e.sort,
            status: e.status
          };
          if (!e.status) {
            e_new = _objectSpread(_objectSpread({}, e_new), {}, {
              disabled: true
            });
          }
          if (e.child) {
            var childList = _this5.addDisabled(e.child);
            e_new = _objectSpread(_objectSpread({}, e_new), {}, {
              child: childList
            });
          }
          list.push(e_new);
        });
      } catch (error) {
        console.log(error);
        return [];
      }
      return list;
    },
    filerMerCateList: function filerMerCateList(treeData) {
      return treeData.map(function (item) {
        if (!item.child) {
          item.disabled = true;
        }
        item.label = item.name;
        return item;
      });
    },
    // 获取商品属性模板；
    productGetRule: function productGetRule() {
      var _this6 = this;
      templateListApi(this.tableFrom).then(function (res) {
        var list = res.list;
        for (var i = 0; i < list.length; i++) {
          list[i].ruleValue = JSON.parse(list[i].ruleValue);
        }
        _this6.ruleList = list;
      });
    },
    // 运费模板；
    getShippingList: function getShippingList() {
      var _this7 = this;
      shippingTemplatesList(this.tempData).then(function (res) {
        _this7.shippingList = res.list;
        // 运费模板未选择时，自动填充选中自提模板
        _this7.setDefaultTempId();
      });
    },
    // 新增/编辑商品时，运费模板自动选中自提模板
    setDefaultTempId: function setDefaultTempId() {
      var selfTemplate = (this.shippingList || []).find(function (item) {
        return item.id == 3;
      });
      if (selfTemplate) {
        this.$set(this.formValidate, 'tempId', selfTemplate.id);
      }
    },
    // 详情
    getInfo: function getInfo() {
      var _this8 = this;
      this.fullscreenLoading = true;
      productDetailApi(this.$route.params.id).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          var info, imgs, imgss;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                // this.isAttr = true;
                info = res;
                _this8.formValidate = _defineProperty(_defineProperty(_defineProperty({
                  image: _this8.$selfUtil.setDomain(info.image),
                  sliderImage: info.sliderImage,
                  sliderImages: JSON.parse(info.sliderImage),
                  storeName: info.storeName,
                  keyword: info.keyword,
                  cateIds: info.cateId.split(','),
                  // 商品分类id
                  cateId: info.cateId,
                  // 商品分类id传值
                  unitName: info.unitName,
                  productType: info.productType + '',
                  // 商品类型：1-商城，2-团购 3-限购
                  temperatureType: info.temperatureType + '',
                  // 温控类型：1-常温，2-冷藏，3-冷冻
                  productDesc: info.productDesc,
                  // 产品列表描述文本
                  descColor: info.descColor,
                  // 文本颜色，十六进制色值
                  couponAllow: info.couponAllow !== undefined ? info.couponAllow : 1,
                  // 是否可以使用优惠券：0-不允许，1-允许
                  limitNum: info.limitNum || 0,
                  // 限购数量，0-不限购
                  cutoffDate: info.cutoffDate || '',
                  // 下架时间（团购商品专用）
                  deliveryTime: info.deliveryTime || '',
                  // 送达时间（团购商品专用，精确到时分秒）
                  sort: info.sort,
                  isShow: info.isShow,
                  isBenefit: info.isBenefit,
                  isNew: info.isNew,
                  isGood: info.isGood,
                  isHot: info.isHot,
                  isBest: info.isBest,
                  tempId: info.tempId,
                  attr: info.attr,
                  attrValue: info.attrValue,
                  selectRule: info.selectRule,
                  isSub: info.isSub,
                  content: info.content ? _this8.$selfUtil.replaceImgSrcHttps(info.content) : '',
                  specType: info.specType,
                  id: info.id,
                  giveIntegral: info.giveIntegral,
                  ficti: info.ficti,
                  coupons: info.coupons,
                  couponIds: info.couponIds,
                  activity: info.activity ? info.activity : ['默认', '秒杀', '砍价', '拼团']
                }, "deliveryTime", info.deliveryTime), "cutoffDate", info.cutoffDate), "ingredientList", info.ingredientList);
                // 获取服务保障被选id列表
                _this8.getGuranteeIdsList(info.guaranteeList);
                marketingSendApi({
                  type: 3
                }).then(function (res) {
                  if (_this8.formValidate.couponIds !== null) {
                    var ids = _this8.formValidate.couponIds.toString();
                    var arr = res.list;
                    var obj = {};
                    for (var i in arr) {
                      obj[arr[i].id] = arr[i];
                    }
                    var strArr = ids.split(',');
                    var newArr = [];
                    var _iterator = _createForOfIteratorHelper(strArr),
                      _step;
                    try {
                      for (_iterator.s(); !(_step = _iterator.n()).done;) {
                        var item = _step.value;
                        if (obj[item]) {
                          newArr.push(obj[item]);
                        }
                      }
                    } catch (err) {
                      _iterator.e(err);
                    } finally {
                      _iterator.f();
                    }
                    _this8.$set(_this8.formValidate, 'coupons', newArr); //在编辑回显时，让返回数据中的优惠券id，通过接口匹配显示,
                  }
                });
                imgs = JSON.parse(info.sliderImage);
                imgss = [];
                Object.keys(imgs).map(function (i) {
                  imgss.push(_this8.$selfUtil.setDomain(imgs[i]));
                });
                _this8.formValidate.sliderImages = [].concat(imgss);
                if (_this8.getFileType(_this8.formValidate.sliderImages[0]) == 'video') {
                  //如果返回数据轮播图的第一张是视频，就将其赋值给videoLink做渲染，同时将其在轮播图中删除
                  _this8.$set(_this8.formValidate, 'videoLink', _this8.formValidate.sliderImages[0]);
                  _this8.formValidate.sliderImages.splice(0, 1);
                }
                if (info.isHot) _this8.checkboxGroup.push('isHot');
                if (info.isGood) _this8.checkboxGroup.push('isGood');
                if (info.isBenefit) _this8.checkboxGroup.push('isBenefit');
                if (info.isBest) _this8.checkboxGroup.push('isBest');
                if (info.isNew) _this8.checkboxGroup.push('isNew');
                _this8.productGetRule();
                // 编辑时若商品未保存运费模板，自动填充选中自提模板
                _this8.setDefaultTempId();
                if (info.specType) {
                  // 设置多规格商品属性数据
                  _this8.generateManyAttr();
                } else {
                  _this8.OneattrValue = info.attrValue;
                  // 分佣类型归一为数字并用 $set 保证响应式，避免连续切换无反应
                  _this8.OneattrValue.forEach(function (item) {
                    _this8.$set(item, 'brokerageType', Number(item.brokerageType) || 1);
                  });
                  // this.formValidate.attr = [] //单规格商品规格设置为空
                }
                _this8.fullscreenLoading = false;
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this8.fullscreenLoading = false;
        _this8.$message.error(res.message);
      });
    },
    handleRemove: function handleRemove(i) {
      this.formValidate.sliderImages.splice(i, 1);
    },
    // 点击商品图
    modalPicTap: function modalPicTap(tit, num, i, status) {
      var _this = this;
      if (_this.isDisabled) return;
      this.$modalUpload(function (img) {
        if (tit === '1' && !num) {
          _this.formValidate.image = img[0].sattDir;
          _this.OneattrValue[0].image = img[0].sattDir;
        }
        if (tit === '2' && !num) {
          if (img.length > 10) return this.$message.warning('最多选择10张图片！');
          if (img.length + _this.formValidate.sliderImages.length > 10) return this.$message.warning('最多选择10张图片！');
          img.map(function (item) {
            _this.formValidate.sliderImages.push(item.sattDir);
          });
        }
        if (tit === '3' && status === 'video') {
          var videoInfo = img[0];
          if (videoInfo.attType !== 'video/mp4') {
            this.$message.warning('请重新选择视频！');
          } else {
            _this.$set(_this.formValidate, 'videoLink', videoInfo.sattDir);
          }
        }
        if (tit === '1' && num === 'dan') {
          _this.OneattrValue[0].image = img[0].sattDir;
        }
        if (tit === '1' && num === 'duo') {
          _this.ManyAttrValue[i].image = img[0].sattDir;
        }
        if (tit === '1' && num === 'pi') {
          _this.oneFormBatch[0].image = img[0].sattDir;
        }
      }, tit, 'content');
    },
    handleSubmitUp: function handleSubmitUp() {
      if (this.currentTab-- < 0) this.currentTab = 0;
      this.currentTab = this.currentTab.toString();
    },
    handleSubmitNest: function handleSubmitNest(name) {
      var _this9 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (_this9.currentTab++ > 3) _this9.currentTab = 0;
          _this9.currentTab = _this9.currentTab.toString();
        } else {
          if (!_this9.formValidate.store_name || !_this9.formValidate.cate_id || !_this9.formValidate.keyword || !_this9.formValidate.unit_name || !_this9.formValidate.store_info || !_this9.formValidate.image || !_this9.formValidate.slider_image) {
            _this9.$message.warning('请填写完整商品信息！');
          }
        }
      });
    },
    //提交接口数据更新
    getFromData: function getFromData() {
      var _this0 = this;
      if (this.formValidate.specType && this.formValidate.attr.length < 1) return this.$message.warning('请填写多规格属性！');
      this.formValidate.cateId = this.formValidate.cateIds.join(',');
      if (this.formValidate.videoLink) {
        //如果有视频主图，将视频链接插入到轮播图第一的位置
        this.formValidate.sliderImages.unshift(this.formValidate.videoLink);
      }
      this.formValidate.sliderImage = JSON.stringify(this.formValidate.sliderImages);
      if (this.formValidate.specType) {
        this.formValidate.attrValue = this.ManyAttrValue.slice(1);
        this.formValidate.attr = this.formValidate.attr.map(function (item) {
          return {
            attrName: item.attrName,
            id: item.id,
            attrValues: item.optionList.map(function (val) {
              return val.value;
            }).join(','),
            isShowImage: item.isShowImage || false,
            optionList: item.optionList || [{
              value: '默认'
            }]
          };
        });
        if (_typeof(this.formValidate.attrValue[0].attrValue) == 'object') {
          this.formValidate.attrValue.forEach(function (item) {
            item.attrValue = JSON.stringify(item.attrValue);
          });
        }
        // 如果不是采集商品
        if (!this.$route.params.isCopy) {
          for (var i = 0; i < this.formValidate.attrValue.length; i++) {
            this.$set(this.formValidate.attrValue[i], 'id', 0);
            this.$set(this.formValidate.attrValue[i], 'productId', 0);
            var attrValues = this.formValidate.attrValue[i].attrValue;
            // this.$set(this.formValidate.attrValue[i], 'attrValue', JSON.stringify(attrValues));
            delete this.formValidate.attrValue[i].value0;
          }
        }
      } else {
        this.formValidate.attr = [{
          attrName: '规格',
          attrValues: '默认',
          id: this.$route.params.id ? this.formValidate.attr[0].id : 0,
          isShowImage: false,
          optionList: [{
            value: '默认'
          }]
        }];
        this.OneattrValue.map(function (item) {
          _this0.$set(item, 'attrValue', JSON.stringify({
            规格: '默认'
          }));
          // 如果佣金设置为默认
          if (!_this0.formValidate.isSub) {
            _this0.$set(item, 'brokerage', 0);
            _this0.$set(item, 'brokerageRate', 0);
          }
          //this.$set(item, 'productId', 0);
        });
        this.formValidate.attrValue = this.OneattrValue;
      }
      this.formValidate.attrValue.forEach(function (item) {
        var type = Number(item.brokerageType) || 1;
        item.brokerageType = type;
        item.brokerageRate = type === 1 ? Number(item.brokerageRate) || 0 : 0;
        item.brokerage = type === 2 ? Number(item.brokerage) || 0 : 0;
        item.brokerageTwo = 0;
      });
    },
    // 校验规格图片：多规格下勾选“添加规格图”的规格，每个规格值必须上传图片
    validateSpecImage: function validateSpecImage() {
      if (!this.formValidate.specType) return true;
      var _iterator2 = _createForOfIteratorHelper(this.formValidate.attr),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var attr = _step2.value;
          if (attr.isShowImage && Array.isArray(attr.optionList)) {
            var missing = attr.optionList.some(function (det) {
              return !det.image;
            });
            if (missing) {
              this.$message.warning("\u89C4\u683C\u201C".concat(attr.attrName, "\u201D\u5DF2\u52FE\u9009\u6DFB\u52A0\u89C4\u683C\u56FE\uFF0C\u8BF7\u4E0A\u4F20\u6240\u6709\u89C4\u683C\u503C\u7684\u56FE\u7247\uFF01"));
              return false;
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return true;
    },
    // 提交
    handleSubmit: Debounce(function (name) {
      var _this1 = this;
      this.onChangeGroup();
      // 校验规格图片
      if (!this.validateSpecImage()) {
        this.currentTab = '1';
        return;
      }
      this.getFromData();
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this1.fullscreenLoading = true;
          _this1.$route.params.id ? productUpdateApi(_this1.formValidate).then(/*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
              return _regenerator().w(function (_context2) {
                while (1) switch (_context2.n) {
                  case 0:
                    _this1.$message.success('编辑成功');
                    setTimeout(function () {
                      _this1.$router.push({
                        path: '/store/index'
                      });
                    }, 500);
                    _this1.fullscreenLoading = false;
                  case 1:
                    return _context2.a(2);
                }
              }, _callee2);
            }));
            return function (_x2) {
              return _ref2.apply(this, arguments);
            };
          }()).catch(function (res) {
            _this1.fullscreenLoading = false;
            _this1.restoreData();
            if (_this1.formValidate.specType) _this1.ManyAttrValue = _this1.formValidate.attrValue;
          }) : productCreateApi(_this1.formValidate).then(/*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(res) {
              return _regenerator().w(function (_context3) {
                while (1) switch (_context3.n) {
                  case 0:
                    _this1.$message.success('新增成功');
                    setTimeout(function () {
                      _this1.$router.push({
                        path: '/store/index'
                      });
                    }, 500);
                    _this1.fullscreenLoading = false;
                  case 1:
                    return _context3.a(2);
                }
              }, _callee3);
            }));
            return function (_x3) {
              return _ref3.apply(this, arguments);
            };
          }()).catch(function (res) {
            _this1.fullscreenLoading = false;
            _this1.restoreData();
          });
        } else {
          if (!_this1.formValidate.storeName || !_this1.formValidate.cateId || !_this1.formValidate.keyword || !_this1.formValidate.unitName || !_this1.formValidate.image || !_this1.formValidate.sliderImages) {
            _this1.$message.warning('请填写完整商品信息！');
          }
        }
      });
    }),
    // 提交失败之后恢复数据
    restoreData: function restoreData() {
      for (var i = 0; i < this.formValidate.attrValue.length; i++) {
        var attrValues = this.formValidate.attrValue[i].attrValue;
        this.$set(this.formValidate.attrValue[i], 'attrValue', JSON.parse(attrValues));
      }
    },
    // 表单验证
    validate: function validate(prop, status, error) {
      if (status === false) {
        this.$message.warning(error);
      }
    },
    // 移动
    handleDragStart: function handleDragStart(e, item) {
      if (!this.isDisabled) this.dragging = item;
    },
    handleDragEnd: function handleDragEnd(e, item) {
      if (!this.isDisabled) this.dragging = null;
    },
    handleDragOver: function handleDragOver(e) {
      if (!this.isDisabled) e.dataTransfer.dropEffect = 'move';
    },
    handleDragEnter: function handleDragEnter(e, item) {
      if (!this.isDisabled) {
        e.dataTransfer.effectAllowed = 'move';
        if (item === this.dragging) {
          return;
        }
        var newItems = _toConsumableArray(this.formValidate.sliderImages);
        var src = newItems.indexOf(this.dragging);
        var dst = newItems.indexOf(item);
        newItems.splice.apply(newItems, [dst, 0].concat(_toConsumableArray(newItems.splice(src, 1))));
        this.formValidate.sliderImages = newItems;
      }
    },
    handleDragEnterFont: function handleDragEnterFont(e, item) {
      if (!this.isDisabled) {
        e.dataTransfer.effectAllowed = 'move';
        if (item === this.dragging) {
          return;
        }
        var newItems = _toConsumableArray(this.formValidate.activity);
        var src = newItems.indexOf(this.dragging);
        var dst = newItems.indexOf(item);
        newItems.splice.apply(newItems, [dst, 0].concat(_toConsumableArray(newItems.splice(src, 1))));
        this.formValidate.activity = newItems;
      }
    },
    // 字典项归一化为 { label, value }（第1个字段为名称，第2个字段为值）
    formatDictionary: function formatDictionary() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var arr = [];
      res.list.map(function (item) {
        var config = JSON.parse(item.value);
        var obj = {};
        config.fields.forEach(function (field) {
          obj[field.name] = field.value;
        });
        arr.push(obj);
      });
      return arr;
    },
    getProductType: function getProductType() {
      var _this10 = this;
      goodDesignList({
        gid: 76
      }).then(function (response) {
        console.log('%c [ response ]-1260', 'font-size:13px; background:pink; color:#bf2c9f;', response);
        _this10.productTypeList = _this10.formatDictionary(response);
      });
    },
    getTemperatureType: function getTemperatureType() {
      var _this11 = this;
      goodDesignList({
        gid: 75
      }).then(function (response) {
        _this11.temperatureTypeList = _this11.formatDictionary(response);
      });
    },
    getGoodsType: function getGoodsType() {
      var _this12 = this;
      /** 让商品推荐列表的name属性与页面设置tab的name匹配**/
      goodDesignList({
        gid: 70
      }).then(function (response) {
        var list = response.list;
        var arr = [],
          arr1 = [];
        var listArr = [{
          name: '是否热卖',
          value: 'isGood',
          type: '5'
        }];
        var typeLists = [{
          name: '',
          value: 'isHot',
          type: '2'
        },
        //热门榜单
        {
          name: '',
          value: 'isBenefit',
          type: '4'
        },
        //促销单品
        {
          name: '',
          value: 'isBest',
          type: '1'
        },
        //精品推荐
        {
          name: '',
          value: 'isNew',
          type: '3'
        }]; //首发新品
        list.forEach(function (item) {
          var obj = {};
          obj.value = JSON.parse(item.value);
          obj.id = item.id;
          obj.gid = item.gid;
          obj.status = item.status;
          arr.push(obj);
        });
        arr.forEach(function (item1) {
          var obj1 = {};
          obj1.name = item1.value.fields[1].value;
          obj1.status = item1.status;
          obj1.type = item1.value.fields[3].value;
          arr1.push(obj1);
        });
        typeLists.forEach(function (item) {
          arr1.forEach(function (item1) {
            if (item.type == item1.type) {
              listArr.push({
                name: item1.name,
                value: item.value,
                type: item.type
              });
            }
          });
        });
        _this12.recommend = listArr;
      });
    },
    // 删除视频；
    delVideo: function delVideo() {
      var that = this;
      that.$set(that.formValidate, 'videoLink', '');
    },
    zh_uploadFile: function zh_uploadFile() {
      if (this.videoLink) {
        this.$set(this.formValidate, 'videoLink', this.videoLink);
      }
    },
    getFileType: function getFileType(fileName) {
      // 后缀获取
      var suffix = '';
      // 获取类型结果
      var result = '';
      try {
        var flieArr = fileName.split('.');
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = '';
      }
      // fileName无后缀返回 false
      if (!suffix) {
        return false;
      }
      suffix = suffix.toLocaleLowerCase();
      // 图片格式
      var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
      // 进行图片匹配
      result = imglist.find(function (item) {
        return item === suffix;
      });
      if (result) {
        return 'image';
      }
      // 匹配 视频
      var videolist = ['mp4', 'm2v', 'mkv', 'rmvb', 'wmv', 'avi', 'flv', 'mov', 'm4v'];
      result = videolist.find(function (item) {
        return item === suffix;
      });
      if (result) {
        return 'video';
      }
      // 其他 文件类型
      return 'other';
    },
    // 获取服务保障列表
    getGuaranteeList: function getGuaranteeList() {
      var _this13 = this;
      guaranteeListApi({
        isShow: 1
      }).then(function (res) {
        _this13.guaranteeList = res;
      }).catch(function (err) {
        _this13.$message.error(err.message);
      });
    },
    // 获取被选服务保障id列表
    getGuranteeIdsList: function getGuranteeIdsList(list) {
      if (list) {
        this.guaranteeIdsList = list.map(function (item) {
          return item.id;
        });
      }
    },
    // 修改服务保障
    updateGuaranteeIds: function updateGuaranteeIds(list) {
      this.formValidate.guaranteeIds = list.join(',');
    },
    // 回调规格生成表格数据 多规格
    changeManyAttrValue: function changeManyAttrValue(e) {
      // rows数组第一项 新增默认数据 oneFormBatch
      this.ManyAttrValue = e;
    },
    //批量清空规格中的批量数据
    handleBatchDel: function handleBatchDel() {
      this.oneFormBatch = [{
        image: '',
        price: void 0,
        cost: void 0,
        otPrice: void 0,
        stock: void 0,
        weight: void 0,
        volume: void 0,
        brokerageType: 1,
        brokerageRate: void 0,
        brokerage: void 0,
        barCode: ''
      }];
    },
    // 设置多规格商品的表格数据
    generateManyAttr: function generateManyAttr() {
      var _this14 = this;
      // 多规格属性赋值
      this.ManyAttrValue = this.formValidate.attrValue;
      this.ManyAttrValue.forEach(function (val) {
        val.image = _this14.$selfUtil.setDomain(val.image);
        val.attrValue = JSON.parse(val.attrValue);
        // 分佣类型归一为数字并用 $set 保证响应式，避免连续切换无反应
        _this14.$set(val, 'brokerageType', Number(val.brokerageType) || 1);
      });
      this.ManyAttrValue = [].concat(_toConsumableArray(this.oneFormBatch), _toConsumableArray(this.ManyAttrValue));
      // 此处手动实现后台原本value0 value1的逻辑
      this.formValidate.attrValue.forEach(function (item) {
        for (var attrValueKey in item.attrValue) {
          item[attrValueKey] = item.attrValue[attrValueKey];
        }
      });
    }
  }
};